import { map, catchError } from 'rxjs/operators';
import { DateService } from '@core/services';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { IPLookup } from '@models/domain';

@Injectable({
    providedIn: 'root'
})
export class IPLookupService{

    constructor(private http: HttpClient) {}

    get(ip: string) : Observable<HttpResponse<IPLookup>> {
        return this.http.get<IPLookup>(env.API_URL + '/ip-lookups/' + ip, {
            params: {},
            observe: 'response'
        }).pipe(
            map( resp => {
                if (resp.body != null && resp.body.ip_address) {
                    resp.body.datetime = DateService.toDateString(resp.body.datetime);
                }
                return resp;
            })
        );
    }

}
